<template>
  <div v-if="totalItems">
    <div class="cart-mode cart-mode-pickup" v-if="isPickup">
      <span class="cart-mode__title">Zur Abholung bestellen:</span>
      <div class="cart-mode__store" v-if="isPickup">
        In Ihrem Markt
        <span class="cart-mode__store-name">{{ selectedStore.name }}</span>
      </div>
    </div>
    <div class="cart-mode cart-mode-delivery" v-else>
      <span class="cart-mode__title">Zur Lieferung bestellen:</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      selectedStore: 'inventorySources/getCurrent',
      isPickup: 'inventorySources/getIsPickup',
      productsInCart: 'cart/getCartItems'
    }),
    totalItems () {
      return this.productsInCart.length;
    }
  }
}
</script>
